import React from "react";
import { MdLightMode, MdDarkMode } from "react-icons/md";
import "./ThemeToggle.scss";
import { useTheme } from "./ThemeProvider";

/*
  Сегментированный переключатель темы: ☀ | ☾.
  Иконки из react-icons — второй набор (@mui) ради двух глифов не тянем.
  На админских роутах тема форсирована светлой, переключатель не рендерим.
*/
const ThemeToggle = ({ className = "" }) => {
  const { theme, setTheme, forcedLight } = useTheme();
  if (forcedLight) return null;

  return (
    <div
      className={"themeToggle " + className}
      role="group"
      aria-label="Тема оформления"
    >
      <button
        type="button"
        className={"themeToggle__btn" + (theme === "light" ? " is-active" : "")}
        aria-pressed={theme === "light"}
        aria-label="Светлая тема"
        onClick={() => setTheme("light")}
      >
        <MdLightMode aria-hidden="true" />
      </button>
      <button
        type="button"
        className={"themeToggle__btn" + (theme === "dark" ? " is-active" : "")}
        aria-pressed={theme === "dark"}
        aria-label="Тёмная тема"
        onClick={() => setTheme("dark")}
      >
        <MdDarkMode aria-hidden="true" />
      </button>
    </div>
  );
};

export default ThemeToggle;
